var map = {
	"./AtSvg": 132,
	"./AtSvg.vue": 132,
	"./HumanSvg": 473,
	"./HumanSvg.vue": 473,
	"./PencilSvg": 4917,
	"./PencilSvg.vue": 4917,
	"./workerDesktop.png": 60,
	"./workerTablet.png": 8086
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8778;